import { createAsyncThunk } from '@reduxjs/toolkit';
import employeeServiceApiInstance from '../../../config/employeeApiConfig';

export const createSkill = createAsyncThunk(
    'resignation/createResignation',
    async (data:any, { rejectWithValue }) => {
      try {  
        const response = await employeeServiceApiInstance.post('/skill', data)
        return response.data;
      } catch (error: any) {
        return rejectWithValue(error.response?.data || 'Failed to create skill');
      }
    }
  );

   export const UpdateSkills = createAsyncThunk<any , {id: number; data: any}, { rejectValue: string }>(
      'skill/updateskills',
      async ({id , data}: {id : number; data: Partial<any>}, { rejectWithValue }) => {
        try {  
          const response = await employeeServiceApiInstance.put(`/skills/${id}`, data)
          return response.data;
        } catch (error: any) {
          return rejectWithValue(error.response?.data || 'Failed to update skills');
        }
      }
    );

    export const deleteSkill = createAsyncThunk(
    'skill/delete',
    async (id: number, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.delete(`/skills/${id}`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to delete Skill');
        }
    }
);


export const  fetchALlSkill = createAsyncThunk(
    'skill/createskill',
    async (_, { rejectWithValue }) => {
      try {  
        const response = await employeeServiceApiInstance.get('/skill')
        return response.data;
      } catch (error: any) {
        return rejectWithValue(error.response?.data || 'Failed to fetch skill');
      }
    }
  );
